import { render } from "./resourcesSection.vue?vue&type=template&id=3ad60890"
import script from "./resourcesSection.vue?vue&type=script&lang=js"
export * from "./resourcesSection.vue?vue&type=script&lang=js"

import "./resourcesSection.vue?vue&type=style&index=0&id=3ad60890&scoop=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__